import { Component, inject } from '@angular/core';
import { faExclamationCircle, faShieldCheck } from '@fortawesome/pro-regular-svg-icons';

import { SurveyEditorService } from '../../../../services/survey-editor.service';

@Component({
  selector: 'empathy-ai-chat-settings',
  templateUrl: 'ai-chat-settings.component.html',
  styleUrls: ['./ai-chat-settings.component.scss']
})
export class AIChatSettingsComponent {
  surveyEditorService = inject(SurveyEditorService);

  faExclamationCircle = faExclamationCircle;
  faShieldCheck = faShieldCheck;
}
